import Drawer from '@mui/material/Drawer'
import PropTypes from 'prop-types'
import {usePersona} from '../../store/hooks/persona'
import {classes, Root} from './PersonaSummary/SummaryComponentStyles'
import SelectedPersona from './IndividualPersona/SelectedPersona'
import SummaryComponent from './PersonaSummary/SummaryComponent'
export default function PersonaSidebar({classesName}) {
  const {personaSidebarOpen} = usePersona()

  return (
    personaSidebarOpen?.open && (
      <Root>
        <Drawer
          className={`${classes.drawer} ${classesName}`}
          variant='persistent'
          anchor='right'
          open={personaSidebarOpen?.open}
          classes={{
            paper: classes.drawerPaper
          }}
        >
          {/* Summary sidebar component here... */}
          {personaSidebarOpen?.component === 'summary' ? (
            <SummaryComponent classesName={classesName} />
          ) : (
            <SelectedPersona />
          )}
          {/* Individual Persona Sidebar here */}
        </Drawer>
      </Root>
    )
  )
}

PersonaSidebar.propTypes = {
  classesName: PropTypes.string.isRequired
}
